import React from 'react';
import { Route, BrowserRouter } from 'react-router-dom';
import get from 'lodash/get';

import SocialShareApp from './social-share-app';

export default class extends React.Component {
  render() {
    const siteRoot = `${get(this.props, 'options.siteContext.siteRoot')}/ds/`;
    
    return (
      <BrowserRouter basename={siteRoot}>
        <Route component={SocialShareApp} />
      </BrowserRouter>
    );
  }
}
